var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.isLoading)?_c(_setup.Loader):[(_setup.currentExportProject)?_c(_setup.Edit):_c(_setup.Create)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }